<template>
    <div>
        
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                      <h5>Selamat Datang {{ userDetail.nama }} | {{ kelas }}</h5><span>Ujian Online Berbasis Komputer Darunnajah</span>
                    </div>
                </div>
              </div>
            </div>

            <!-- konfirmasi modal -->
            <b-modal id="add-modal" title="Konfirmasi Tes" hide-footer>
                <div class="card-body">
                    
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <table>
                                    <tr>
                                        <td>Nama</td>
                                        <td><b>{{ userDetail.nama }}</b></td>
                                    </tr>
                                    <tr>
                                        <td>Tes</td>
                                        <td><b>{{ currentDataTest.title }}</b></td>
                                    </tr>
                                    <tr>
                                        <td>Waktu</td>
                                        <td>{{ currentDataTest.durasi }} menit</td>
                                    </tr>
                                </table>                                
                            </div>
                        </div>
                    </div>     

                    <div>
                        <b-button @click="mulaiUjian(currentDataTest)" type="submit" variant="primary" class="mr-1">Kerjakan</b-button>                                                    
                    </div>    
                </div>
            </b-modal>


            <div class="row">
              <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                      <h6>Daftar Tes</h6>
                    </div>
                    <div class="card-body">
                      <div class="table-responsive datatable-vue m-0 vue-smart">
                      <v-table
                          :data="listBelumAtauSedangTest" class="table"
                          :currentPage.sync="basic.currentPage"
                          :pageSize="100"
                          @totalPagesChanged="basic.totalPages = $event"
                      >
                        <thead slot="head">
                        <v-th>No</v-th>
                        <v-th sortKey="tingkat">Tes</v-th>
                        <v-th>Waktu Mulai Tes</v-th>
                        <v-th>Waktu Selesai Tes</v-th>                        
                        <v-th>Status</v-th>
                        <v-th>Action</v-th>
                        </thead>
                        <tbody slot="body" slot-scope="{displayData}">
                        <tr v-for="(row, index) in displayData" :key="row.id">
                          <td>{{ index + 1 }}</td>
                          <td>{{ row.title }}</td>
                          <td>{{ convertDate(row.begin) }}</td>
                          <td>{{ convertDate(row.end) }}</td>
                          <td>{{ row.statusText }}</td>                          
                          <td v-if="isNew(row.statusText)">
                                <b-button @click="konfirmasiTest(row)" variant="primary" class="mr-1" size="sm" style="display:flex; justify-content:space-around; align-items:center; ">
                                    <feather type="arrow-right" stroke="white"></feather> {{ row.statusText }}
                                </b-button>
                                
                            </td>
                            <td v-else-if="isLanjut(row.statusText)">                                
                                <b-button @click="lanjutTest(row)" variant="primary" class="mr-1" size="sm" style="display:flex; justify-content:space-around; align-items:center; ">
                                    <feather type="arrow-right" stroke="white"></feather> {{ row.statusText }}
                                </b-button>
                            </td>								
                            <td v-else></td>		
                        </tr>
                        </tbody>
                      </v-table>

                      <smart-pagination
                          :currentPage.sync="basic.currentPage"
                          :totalPages="basic.totalPages"
                      />
                    </div>
                    </div>
                </div>
              </div>               
            </div>
        </div>
        <!-- Container-fluid Ends-->

        <div class="loader" v-if="loader"></div>
    </div>
</template>

<script>
    import {url} from "@/urls";
    import {service} from '@/services';
    import {helper} from '@/services/helper';
    import * as _ from 'underscore';
    import moment from 'moment';

    export default {
        data(){
            return{                
                savedBulkSoal: [],
                dataSoalByTopik: [],
                userDetail: {},
                idtestsiswa: null,
                currentDataTest: {},
                listBelumAtauSedangTest: [],
                kelas: "",
                selectedPeriode: 0,
                userDetail: {},
                idkelas: null,                
                loader:false,
                basic:{
                    currentPage: 1,
                    totalPages: 0,
                },                
                reserveIdTest: []  
            }
        },
        methods: {
            isNew(status) {
                console.log("STATUS", status)
                return status == "Kerjakan";
            },
            isLanjut(status) {
                return status == "Lanjutkan";
            },
            saveSiswaTest(mulaiDataTest) {
                this.loader = true;
                let createdDate = moment();                

                let body = { 
                    idtenant: mulaiDataTest.idtenant,
                    idtest: mulaiDataTest.id,
                    idsiswa: this.userDetail.iduser,                    
                    created: createdDate                                           
                }
                console.log(body);
                
                service.onPost(url.cbt_test_siswa, body)
                    .then(result => {
                        
                        console.log('save siswa test', result);
                        this.idtestsiswa = result.data.id;
                        this.loader = false;                        
                        //1
                        this.acakSoal();
                        					
                    }).catch(error => {
                        setTimeout(() => {
                            // eslint-disable-next-line
                            console.log(error);
                            this.$toasted.show(" Terjadi kesalahan input, silahkan diulangi kembali ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                            this.loader = false;
                        }, 1000);
                        this.cancelAdd()
                    })
            },

            saveJawabanPg() {

                this.savedBulkSoal

                let sIdSoal = [];
                var i = 0;
                for (i=0;i<this.savedBulkSoal.length;i++) {
                    sIdSoal[this.savedBulkSoal[i].idsoal] = this.savedBulkSoal[i].id;
                }

                console.log('this.dataSoalByTopik', this.dataSoalByTopik);
                // idjawaban
                // idtestsoal
                // selected
                // order
                                                
                let bulkDataJawaban = [];
                let objBulkJawaban = {};
                let shuffleJawaban = [];

                var s=0;
                var c=0;
                for (s=0;s<this.dataSoalByTopik.length;s++) {
                    if (this.dataSoalByTopik[s].tipe === "PG") {
                        shuffleJawaban = _.shuffle(this.dataSoalByTopik[s].Jawaban);

                        console.log('shuffleJawaban', shuffleJawaban);
                        
                        for (c=0;c < shuffleJawaban.length;c++) {
                            objBulkJawaban['idtenant'] = this.userDetail.idtenant;
                            objBulkJawaban['idjawaban'] = shuffleJawaban[c].id;
                            objBulkJawaban['idtestsoal'] = sIdSoal[this.dataSoalByTopik[s].id];                            
                            objBulkJawaban['order'] = c+1;
                            bulkDataJawaban.push(objBulkJawaban);
                            objBulkJawaban = {};
                        }
                        
                    }
                }

                if (bulkDataJawaban.length > 0) {
                    this.loader = true;
                    service.onPost(`${url.cbt_test_jawaban_bulk_update}`, bulkDataJawaban)
                        .then((res) => {
                            console.log("BULK RESULT JAWABAN ", res.data)
                            if (res.status == 200) {                                
                                this.$toasted.show(" Konfirmasi ujian berhasil ", {theme: 'outline',position: "top-right", type: 'success', duration: 1000});
                                setTimeout(() => {
                                    this.loader = false;    
                                    localStorage.setItem("idtestsiswa", this.idtestsiswa)                                    
                                    this.$router.push({ name: 'JawabSoal', params: { idtest: this.idtestsiswa } })                                                                                                 
                                }, 1000);                                                                             
                            }
                        })
                        .catch((err) => {
                            console.log(err)
                            //this.$toasted.show(" Terjadi kesalahan input, pastikan data yang diupload sesuai dengan format data ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                            this.loader = false;                        
                        })
                } else {
                    this.$toasted.show(" Konfirmasi ujian berhasil ", {theme: 'outline',position: "top-right", type: 'success', duration: 1000});
                    setTimeout(() => {
                        this.loader = false;    
                        localStorage.setItem("idtestsiswa", this.idtestsiswa)                        
                        this.$router.push({ name: 'JawabSoal', params: { idtest: this.idtestsiswa } })                                                                                     
                    }, 1000);
                }
            },

            saveSoalSiswa(dataSoalAcak) {
                this.loader = true;
                service.onPost(`${url.cbt_test_soal}/bulkupload`, dataSoalAcak)
                    .then((res) => {
                        console.log("BULK RESULT ", res.data)
                        if (res.status == 200) {
                            this.savedBulkSoal = res.data;                            
                            this.saveJawabanPg();
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                        //this.$toasted.show(" Terjadi kesalahan input, pastikan data yang diupload sesuai dengan format data ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                        this.loader = false;                        
                    })
            },
            getSoalByIdTopik(mulaiDataTest) {
                this.loader = true;

                service.onGet(`${url.soal}/topik/${mulaiDataTest.idtopik}`)
                .then((result) => {
                    console.log("Soal by topik ",result.data)
                    this.dataSoalByTopik = result.data;                     
                    this.loader = false;

                    if (result.data && result.data.length > 0) {
                        this.saveSiswaTest(mulaiDataTest);
                    } else {
                        // show soal warning
                        this.$swal({
                            icon: 'warning',
                            title: `Data soal belum ada!`,
                            text : `Silahkan ulangi kembali.`,
                            showCancelButton: false,                                        
                            confirmButtonText: `Ya`,
                        }).then((res) => {
                            if (res.isConfirmed) {
                                this.$router.push({name:'DashboardSiswa'});                                            
                            }
                        });
                    }                                                            
                })
                .catch((errperiode) => {
                    this.loader = false;
                    console.log(errperiode)
                })
            },

            acakSoal() {
                if (this.dataSoalByTopik.length > 0) {                                                    
                    //let _shuffle = _.shuffle(result.data);
                    //console.log("Soal by topik shuffle ",_shuffle)
                    var i = 0;
                    let obj = {}
                    let acak = [];
                    // soal tidak diacak
                    //for (i=0; i<_shuffle.length; i++) {
                    for (i=0; i<this.dataSoalByTopik.length; i++) {
                        obj['idtenant'] = this.userDetail.idtenant   
                        //obj['idsoal'] = _shuffle[i].id
                        obj['idsoal'] = this.dataSoalByTopik[i].id
                        obj['idtestsiswa'] = this.idtestsiswa
                        obj['order'] = i+1                                                    
                        acak.push(obj) 
                        obj={}
                    }

                    console.log('soal acak', acak)
                    this.saveSoalSiswa(acak)
                
                }
            },
            mulaiUjian(mulaiDataTest) {
                console.log(mulaiDataTest);
                
                this.$bvModal.hide('add-modal')
                
                // 1. save cbt user test
                // 2. get soal by idtopic
                // 3. acak soal
                // 4. save to cbt test soal
                // for pilihan ganda
                // 5. get cbt jawaban
                // 6. acak jawaban
                // 7. save cbt test soal jawaban
                
                this.getSoalByIdTopik(mulaiDataTest);
                
                
            },
            konfirmasiTest(dataTes) {
                this.currentDataTest = dataTes;
                this.$bvModal.show('add-modal')
            },
            lanjutTest(dataTes) {
                console.log("data lanjut ", dataTes, this.userDetail.idtenant)
                service.onGet(`${url.soal}/topik/${dataTes.idtopik}`)
                .then((result) => {
                    console.log("Soal by topik ",result.data)
                    this.dataSoalByTopik = result.data;

                    // check ujian upload or not                    
                                        
                    localStorage.setItem("idtestsiswa", dataTes.idtestsiswa)
                    
                    this.$router.push({ name: 'JawabSoal', params: { idtest: dataTes.idtestsiswa } })                    
                })
                .catch((errperiode) => {
                    this.loader = false;
                    console.log(errperiode)
                })                                                             
            },
            convertDate(date) {
              return moment(date).format('YYYY-MM-DD HH:mm');  
            },

            getCbtTestSiswa() {
                this.loader = true;
            
                service.onGet(`${url.cbt_test_siswa_get_by_tenant}/${this.userDetail.idtenant}/${this.userDetail.iduser}`)
                .then((result) => {
                    console.log("TEST PROGRESS ",result.data)
                    
                    this.loader = false;
                    if (result.data) {
                        //this.listBelumAtauSedangTest = result.data;
                        var i = 0;
                        for (i=0;i<result.data.length; i++) {
                            this.reserveIdTest.push(result.data[i].idtest)
                            result.data[i].Test.statusText = result.data[i].status == false ? "Selesai" : "Lanjutkan";
                            result.data[i].Test.idtestsiswa = result.data[i].id;
                            this.listBelumAtauSedangTest.push(result.data[i].Test)    
                        }
                        console.log("list belum ", this.listBelumAtauSedangTest)
                        this.getCbtTest();
                    }
                      
                })
                .catch((errperiode) => {
                    this.loader = false;
                    console.log(errperiode)
                })
            },
            getCbtTest() {
                this.loader = true;
            
                service.onGet(`${url.cbt_test_get_by_kelas}/${this.userDetail.idtenant}/${this.idkelas}`)
                .then((result) => {
                    console.log("BLAH ",result.data)
                    
                    this.loader = false;
                    if (result.data) {
                        //this.listBelumAtauSedangTest = result.data;
                        //var n = fruits.includes(22);
                        var i = 0;
                        for (i=0;i<result.data.length; i++) {
                            if (!this.reserveIdTest.includes(result.data[i].id)) {
                                result.data[i].statusText = "Kerjakan";
                                this.listBelumAtauSedangTest.unshift(result.data[i]);    
                            }
                        }
                    }                                        
                })
                .catch((errperiode) => {
                    this.loader = false;
                    console.log(errperiode)
                })
            },
            getSiswaKelas(){
                this.loader = true;
                
                service.onGet(`${url.periode_get_aktif_periode}/${this.userDetail.idtenant}`)
                .then((resperiode) => {
                    console.log(resperiode.data)
                    this.selectedPeriode = resperiode.data[0].id
                    
                    service.onGet(url.master_siswa_get_by_periode + "/" + this.selectedPeriode + "/" + this.userDetail.idtenant + "/" + this.userDetail.iduser)
                    .then(result => {
                        console.log(result.data);
                        this.loader = false;
                        if (result.data.length > 0) {
                            this.idkelas = result.data[0].Walikelas[0].idkelas;                            
                            this.getCbtTestSiswa();
                        }
                    }).catch(error => {
                        this.loader = false;
                        console.log(error)
                    })  
                })
                .catch((errperiode) => {
                    this.loader = false;
                    console.log(errperiode)
                })                
            },
            async checkUserStatus() {
                try {
                    let endpoint = "siswa"
                    let siswa = await service.onGet(`${endpoint}/${this.userDetail.iduser}`)
                    console.log('user status', siswa)
                    if (!siswa.data.status) {
                        //logout
                        localStorage.clear();
                        this.$router.push({name:'Login'})
                    }
                } catch (error) {
                    console.log(error)                    
                }                
            }            
        },
        mounted() {
            
            let user = localStorage.getItem("user");
            if (user) {
                this.userDetail = helper.getUserObject(user);

                console.log("USER", this.userDetail);

                if (!this.userDetail.status) {
                    localStorage.clear();
                    this.$router.push({name:'Login'})
                } else {
                    this.checkUserStatus();
                    this.getSiswaKelas();
                }
            }            
        },
        computed: {
            
        }
    }
</script>